import { Box, FormControl, Grid, InputLabel, MenuItem, Select } from "@material-ui/core";
import dayjs from "dayjs";
import React, { useMemo, useState, useEffect } from "react";

const MONTHS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export default function MonthYearPicker({
  initialDate = null,
  maxYearOffset = 10,
  value = {month:1,year:2025},
  onMonthChange = () => {},
  onYearChange = () => {},
  className = "",
}) {
  // const refDate = useMemo(() => {
  //   if (initialDate instanceof Date && !isNaN(initialDate)) return initialDate;
  //   return new Date();
  // }, [initialDate]);
console.log("kjlasdhgkjlashdkjalhdas",value)
  // const refYear = refDate.getFullYear();
  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth();
  const maxYear = currentYear;
  const maxMonths=value.year!=currentYear?12:currentMonth-1;
  // const [month, setMonth] = useState(() => (value ? value.month : new Date().getMonth()));
  // const [year, setYear] = useState(() =>
  //   value ? value.year : Math.max(value.year + 1, new Date().getFullYear())
  // );

  // useEffect(() => {
  //   if (value) {
  //     if (typeof value.month === "number" && !isNaN(value.month)) setMonth(value.month);
  //     if (typeof value.year === "number" && !isNaN(value.year)) setYear(value.year);
  //   }
  // }, [value]);

  const yearOptions = useMemo(() => {
    const start = dayjs(initialDate).year();
    const years = [];
    for (let y = start; y <= maxYear; y++) years.push(y);
    return years;
  }, [value, maxYear]);

  // useEffect(() => {
  //   if (yearOptions.length === 0) return;
  //   if (!yearOptions.includes(value.year)) {
  //     // onYearChange(yearOptions[0]);
  //   }
  // }, [yearOptions, value.year]);


  return (
    <Grid container spacing={3}>
        <Grid item sm={12} md={6} lg={6}>
<FormControl variant="outlined" size="small" fullWidth style={{ minWidth: 140 }}>
        <InputLabel id="month-label">Month</InputLabel>
        <Select
          labelId="month-label"
          value={value.month}
          onChange={(e) => {onMonthChange(Number(e.target.value))
            if(onMonthChange)onMonthChange(e.target.value)
          }}
          label="Month"
        >
          {MONTHS.map((m, i) => i<=maxMonths ? (
            <MenuItem key={m} value={i+1}>
              {m}
            </MenuItem>
          ):null)}
        </Select>
      </FormControl>
        </Grid>
        <Grid item sm={12} md={6} lg={6}>
      <FormControl variant="outlined" size="small" fullWidth style={{ minWidth: 140 }}>
        <InputLabel id="year-label">Year (after {dayjs(initialDate).year()})</InputLabel>
        <Select
          labelId="year-label"
          value={value.year}
          onChange={(e) => {
            // setYear(Number(e.target.value))
            onYearChange(e.target.value)
          }}
          label={`Year (after ${value.year})`}
        >
          {yearOptions.length === 0 ? (
            <MenuItem value="">No years available</MenuItem>
          ) : (
            yearOptions.map((y) => (
              <MenuItem key={y} value={y}>
                {y}
              </MenuItem>
            ))
          )}
        </Select>
      </FormControl>
        </Grid>
    </Grid>

  );
}
